"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.groupOrderLinesByDate = void 0;
const dayjs = require("dayjs");
const advancedFormat = require("dayjs/plugin/advancedFormat");
dayjs.extend(advancedFormat);
const groupOrderLinesByDate = (order_lines) => {
    if (!order_lines?.length)
        return [];
    // Normalize region order by first encounter
    const unique_regions = [...new Set(order_lines.map((l) => l.region_id))];
    // --- Step 1: Group by normalized date ---
    const grouped_map = new Map();
    for (const line of order_lines) {
        const date = dayjs(line.start_date).format("YYYY-MM-DD");
        if (!grouped_map.has(date)) {
            grouped_map.set(date, {
                date,
                date_friendly: dayjs(date).format("ddd, Do MMM YYYY"),
                order_lines: [],
            });
        }
        grouped_map.get(date).order_lines.push(line);
    }
    // --- Step 2: Convert map to array and sort groups ---
    const grouped_lines = Array.from(grouped_map.values());
    grouped_lines.sort((a, b) => {
        const dateDiff = dayjs(a.date).diff(dayjs(b.date), "day");
        if (dateDiff !== 0)
            return dateDiff;
        // If same date, order by first region priority
        const aRegion = a.order_lines[0]?.region_id;
        const bRegion = b.order_lines[0]?.region_id;
        return unique_regions.indexOf(aRegion) - unique_regions.indexOf(bRegion);
    });
    // --- Step 3: Sort order_lines inside each group ---
    for (const group of grouped_lines) {
        group.order_lines.sort((a, b) => {
            if (a.region_id === b.region_id) {
                return (a.order_weight ?? 0) - (b.order_weight ?? 0);
            }
            return (unique_regions.indexOf(a.region_id) -
                unique_regions.indexOf(b.region_id));
        });
    }
    // --- Step 4: Fill missing day gaps ---
    const result_lines = [];
    grouped_lines.forEach((group, idx) => {
        if (idx === 0) {
            result_lines.push({
                ...group,
                days_diff: 0,
                has_gap: false,
                multi_day_gap: false,
            });
            return;
        }
        const prev = result_lines[result_lines.length - 1];
        const prevDate = dayjs(prev.date);
        const currDate = dayjs(group.date);
        const daysDiff = currDate.diff(prevDate, "day") - 1;
        if (daysDiff === 1) {
            const missingDate = prevDate.add(1, "day");
            result_lines.push({
                date: missingDate.format("YYYY-MM-DD"),
                date_friendly: missingDate.format("ddd, Do MMM YYYY"),
                order_lines: [],
                days_diff: 0,
                has_gap: false,
                multi_day_gap: false,
            });
        }
        result_lines.push({
            ...group,
            days_diff: daysDiff,
            has_gap: daysDiff > 0,
            multi_day_gap: daysDiff > 1,
        });
    });
    return result_lines;
};
exports.groupOrderLinesByDate = groupOrderLinesByDate;
